'use client';
import { InnerContainer } from '@/src/features/ui/common/inner-container';
import classNames from 'classnames';
import { ListItem } from './list-item';
import { IMockData } from './mock-data';

interface Props {
  legalTexts: IMockData;
}

export const LegalTexts: React.FC<Props> = (props) => {
  const ulStyle = `md:inline-block flex overflow-auto whitespace-nowrap hidden-scrollbar gap-x-3`;
  const ulUnderLineStyle = `after:content-[""]`;

  return (
    <InnerContainer pxZero>
      <section className="mb-8">
        <div>
          <nav>
            <ul className={classNames(ulStyle, ulUnderLineStyle)}>
              {Object.entries(props.legalTexts).map(([key, value]) => {
                return <ListItem key={value?.url} redirectTitle={value?.redirectTitle} url={value?.url} />;
              })}
            </ul>
            <hr className="md:hidden" />
          </nav>
        </div>
      </section>
    </InnerContainer>
  );
};
